import { createAction } from '@reduxjs/toolkit';

import { SaveBookDetailsAction, ChangeFolderAction, ChangeExtraVisabilityAction } from '@shared/types';

export const actions = {
  saveBookDetailsAction: createAction<SaveBookDetailsAction>('book/saveBookDetailsAction'),
  changeFolderClick: createAction<ChangeFolderAction>('book/changeFolderClick'),
  changeExtraVisability: createAction<ChangeExtraVisabilityAction>('book/changeExtraVisability'),
};
